export const firebaseErrorMessages: Record<string, string> = {
    'auth/invalid-credential': 'Недействительные учётные данные. Попробуйте снова.',
    'auth/wrong-password': 'Неверный пароль. Попробуйте другой или используйте "Забыли пароль?".',
    'auth/user-not-found': 'Такой пользователь не найден. Проверьте адрес или зарегистрируйтесь.',
    'auth/email-already-in-use': 'Пользователь с такой почтой уже существует',
    'auth/network-request-failed': 'Проверьте соединение и попробуйте снова',
    'auth/invalid-email': 'Неверный формат почты'
};

export const extractFirebaseErrorCode = (errorMessage: string): string | null => {
    const match = errorMessage?.match(/\(([^)]+)\)/);
    return match ? match[1] : null;
};